import { Stack, Typography } from "@mui/material";
import React from "react";

const Subscription = () => {
  return (
    <>
      <Stack gap={1} alignItems={"center"}>
        <Typography variant="h1" color="initial">
        My subscription
        </Typography>
        <Typography variant="body2" color="initial">
        Manage your subscriptions easily with tailored settings
        </Typography>
      </Stack>
    </>
  );
};

export default Subscription;
